// extracted by mini-css-extract-plugin
module.exports = {"SuccessSpinner":"SuccessSpinner_SuccessSpinner__1b2jw"};